import { render, staticRenderFns } from "./PriorityVote.vue?vue&type=template&id=91931c60&scoped=true"
import script from "./PriorityVote.vue?vue&type=script&lang=ts"
export * from "./PriorityVote.vue?vue&type=script&lang=ts"
import style0 from "./PriorityVote.vue?vue&type=style&index=0&id=91931c60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91931c60",
  null
  
)

export default component.exports